import React from 'react';

import useAutomatedTime from 'hooks/useAutomatedTime';
import FileManagerContainer from './FileManagerContainer.jsx';
import GlobalLoader from 'components/GlobalLoader/GlobalLoader';
import { FileManagerContextProvider } from '../../context/FileManagerContext';

function NewFileManager(props) {
  const { onMountUnMount, onOperationBreak } = useAutomatedTime(
    props?.caseDetails?.case_id,
    props?.caseDetails?.case_description?.case_name
  );

  return (
    <FileManagerContextProvider {...props} onMountUnMount={onMountUnMount} onOperationBreak={onOperationBreak}>
      <GlobalLoader />
      <FileManagerContainer />
    </FileManagerContextProvider>
  );
}

export default NewFileManager;
